'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const BookingVolumeChart = dynamic(() => import('./BookingVolumeChart'), { ssr: false });
const ServiceBreakdownChart = dynamic(() => import('./ServiceBreakdownChart'), { ssr: false });

export default function BookingChartsRow() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
      <div className="lg:col-span-2 bg-card rounded-xl border border-border shadow-card p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-700 text-foreground">Booking Volume — Last 7 Days</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Confirmed + completed bookings per day</p>
          </div>
          <span className="text-xs font-500 text-muted-foreground bg-muted px-3 py-1 rounded-lg">May 6–12</span>
        </div>
        <BookingVolumeChart />
      </div>
      <div className="bg-card rounded-xl border border-border shadow-card p-5">
        <div className="mb-4">
          <h3 className="text-sm font-700 text-foreground">Service Mix</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Bookings by service type this month</p>
        </div>
        <ServiceBreakdownChart />
      </div>
    </div>
  );
}